var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"item-text":_vm.itemText,"item-value":_vm.itemValue,"value":_vm.value,"search-input":_vm.search,"items":_vm.items},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();$event.preventDefault();return (() => {}).apply(null, arguments)}},scopedSlots:_vm._u([{key:"item",fn:function({ parent, item, on, attrs }){return [_vm._t("item",function(){return [_c('div',[_vm._v(_vm._s(item[_vm.itemText]))])]},{"parent":parent,"item":item,"on":on,"attrs":attrs})]}}],null,true)},'v-autocomplete',{
        dense: true,
        outlined: true,
        multiple: true,
        chips: true,
        smallChips: true,
        deletableChips: true,
        hideDetails: 'auto',
        noFilter: true,
        ..._vm.$attrs,
    },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }